"use strict";var e=require("react"),o=require("../../Typography-5417a9c6.js"),t=require("../../noop-8f256ff1.js"),a=require("styled-components");function r(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}require("prop-types");var n=r(e),i=r(a),l={categories:{default:{shared:{"container-shadow":"shadow-low-up","container-padding-x":"spacing-component-3xlarge","container-padding-top":"spacing-component-large","container-padding-bottom":"spacing-component-4xlarge","background-color":"shape-color-background-primary","icon-width":"icon-size-medium","icon-area-width":"icon-size-xlarge","icon-area-height":"icon-size-medium","icon-area-border-radius":"border-radius-xsmall","icon-color":"icon-color-primary","option-gap-y":"spacing-component-small","option-padding-x":"spacing-component-xsmall","label-max-width":"size-15"},states:{enabled:{"background-color":"shape-color-surface-action-default-enabled"},hover:{"background-color":"shape-color-surface-action-default-hover"},pressed:{"background-color":"shape-color-surface-action-default-pressed"}}}},properties:{fonts:{label:{"text-color":"text-color-action-hover-loud",typography:"text-base-small"},"label-selected":{"text-color":"text-color-action-pressed-default",typography:"text-highlight-small"}}}};const{categories:{default:c}}=l,d=i.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({theme:e})=>e.borderRadius(c.shared["icon-area-border-radius"])};
  width: ${({theme:e})=>e.size(c.shared["icon-area-width"])};
  height: ${({theme:e})=>e.size(c.shared["icon-area-height"])};
  transition: background-color 150ms cubic-bezier(0.42, 0, 0.58, 1);

  button:hover & {
    background-color: ${({theme:e})=>e.color(c.states.hover["background-color"])};
  }

  button:active & {
    background-color: ${({theme:e})=>e.color(c.states.pressed["background-color"])};
    transition: background-color 75ms cubic-bezier(0.42, 0, 0.58, 1);
  }
`,s=i.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;function p({selected:e,children:o}){return n.default.createElement(d,null,n.default.createElement(s,null,n.default.cloneElement(o,{size:"medium",filled:e})))}const{categories:{default:u}}=l,h=i.default.nav`
  position: fixed;
  bottom: 0px;
  box-sizing: border-box;
  display: flex;
  padding-top: ${({theme:e})=>e.space(u.shared["container-padding-top"])};
  background-color: ${({theme:e})=>e.color(u.shared["background-color"])};
  box-shadow: ${({theme:e})=>e.boxShadow(u.shared["container-shadow"])};
  width: 100%;
`,g=i.default.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${({theme:e})=>`0 ${e.space(u.shared["container-padding-x"])}`};
  margin-bottom: ${({theme:e})=>e.space(u.shared["container-padding-bottom"])};
`,m=i.default.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: ${({theme:e})=>e.size(u.shared["icon-width"])};
`,b=i.default.div`
  text-align: center;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: ${({theme:e})=>e.space(u.shared["option-gap-y"])};
`,{properties:{fonts:f}}=l;module.exports=function({selectedId:e,options:a=[],onSelect:r=t.noop}){return n.default.createElement(h,null,n.default.createElement(g,{role:"tablist"},a.map((t=>{const a=e===t.id;return n.default.createElement(m,{role:"tab",key:t.id,selected:a,"aria-selected":a,onClick:()=>r(t.id)},n.default.createElement(p,{selected:a},t.icon),n.default.createElement(b,null,n.default.createElement(o.Typography,{token:a?f["label-selected"].typography:f.label.typography,color:a?f["label-selected"]["text-color"]:f.label["text-color"]},t.text)))}))))};
